import gsap from "gsap";

document.addEventListener("DOMContentLoaded", () => {
  const partBlockContainers = document.querySelectorAll(".part-block__container");

  for (let i = 0; i < partBlockContainers.length; i++) {
    let partBlockContainer = partBlockContainers[i];
    const partBlock = partBlockContainer.querySelector(".part-block");

    if (partBlock) {
      const materialSwitcher1 = partBlock.querySelector(".part-block__content .tuning-buttons__material .tuning-buttons__input");
      const timeLine = gsap.timeline();

      let material1 = materialSwitcher1.dataset.unchecked.toLowerCase();
      let material2 = materialSwitcher1.dataset.checked.toLowerCase();
      if (material1 && material2) {
        let material1Block = partBlockContainer.querySelector(`.part-block[data-material=${material1}]`);
        let material2Block = partBlockContainer.querySelector(`.part-block[data-material=${material2}]`);
        if (material1Block && material2Block) {
          const materialSwitcher2 = material2Block.querySelector(".part-block__content .tuning-buttons__material .tuning-buttons__input");

          //synchronize switchers
          materialSwitcher1.addEventListener("change", (e) => {
            materialSwitcher2.checked = e.target.checked;
            changeMaterial();
          });
          materialSwitcher2.addEventListener("change", (e) => {
            materialSwitcher1.checked = e.target.checked;
            changeMaterial();
          });

          const changeMaterial = () => {
            partBlockContainer.style.pointerEvents = "none";
            if (!materialSwitcher1.checked) {
              partBlockContainer.style.height = material2Block.offsetHeight + parseInt(window.getComputedStyle(material2Block).marginBottom) + "px";
              timeLine.to(material2Block, {
                duration: 0.3,
                autoAlpha: 0,
                display: "none",
              });
              timeLine.to(material1Block, {
                duration: 0.3,
                autoAlpha: 1,
                display: "flex",
                onComplete: () => {
                  partBlockContainer.style.height = "unset";
                  partBlockContainer.style.pointerEvents = "all";
                },
              });
            } else {
              partBlockContainer.style.height = material1Block.offsetHeight + parseInt(window.getComputedStyle(material1Block).marginBottom) + "px";
              timeLine.to(material1Block, {
                duration: 0.3,
                autoAlpha: 0,
                display: "none",
              });
              timeLine.to(material2Block, {
                duration: 0.3,
                autoAlpha: 1,
                display: "flex",
                onComplete: () => {
                  partBlockContainer.style.height = "unset";
                  partBlockContainer.style.pointerEvents = "all";
                },
              });
            }
          };
          changeMaterial();
        }
      }
    }
  }
});
